import { render, staticRenderFns } from "./ActivityQRCode.vue?vue&type=template&id=710326d1"
import script from "./ActivityQRCode.vue?vue&type=script&lang=js"
export * from "./ActivityQRCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports